import {
  borderRadius,
  Colorset,
  getColorset,
  IconCheckFill,
  Placeholder,
  spacing,
  styled,
} from '@lessonup/ui-components';
import React from 'react';
import { useEditorTranslation } from '../../../../hooks/useEditorTranslation';

interface ImageSelectorProps {
  onClick: () => void;
  active: boolean;
  index: number;
  imageUrl: string;
}

export const ImageSelector: React.FC<ImageSelectorProps> = ({ onClick, active, index, imageUrl }) => {
  const { t } = useEditorTranslation();
  const colors = getColorset('neutral', { active });
  const [imageError, setImageError] = React.useState(false);

  return (
    <StyledImageSelector
      onClick={onClick}
      colors={colors}
      active={active}
      aria-label={t('contextSidebar.settings.imageSelectorLabel', { index: index + 1 })}
    >
      {imageError || imageUrl === '' ? (
        <Placeholder style={{ width: '100%' }} />
      ) : (
        // Alt attribute is ignored because the parent has a aria-label and there is a placeholder for when the image fails to load
        // eslint-disable-next-line jsx-a11y/alt-text
        <img src={imageUrl} draggable={false} onError={() => setImageError(true)} />
      )}
      <StyledIconWrapper active={active}>
        <IconCheckFill />
      </StyledIconWrapper>
    </StyledImageSelector>
  );
};

const StyledImageSelector = styled.button<{ active: boolean; colors: Colorset }>`
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  min-height: ${spacing.size32};
  border-radius: ${borderRadius.rounded4};
  border: 2px solid ${({ colors }) => colors.stroke}; //ToDo: add luminosity border in TECH-178
  color: ${({ colors }) => colors.on};

  & > :first-child {
    display: block;
    max-width: 100%;
    height: auto;
    overflow: hidden;
    border-radius: ${borderRadius.rounded2};
  }

  :hover {
    svg {
      opacity: 1;
    }
  }
`;

const StyledIconWrapper = styled.div<{ active?: boolean }>`
  position: absolute;
  top: ${spacing.size4};
  left: ${spacing.size4};

  svg {
    opacity: ${({ active }) => (active ? 1 : 0)};
    width: ${spacing.size16};
    height: ${spacing.size16};
  }
`;
